export function canUseDynamicWheel(email: string | null | undefined): boolean {
  return ['marketing@bove.com.au', 'robyu@modkingz.com.au'].includes(email?.trim().toLowerCase() ?? '');
}
